module.exports = __webpack_public_path__ + "img/stack03.954f057d.svg";